/*!
* jQuery Custom-form-elements plugin
* Author: Globalia
* Licensed under the WTFPL license
*/



( function( global ) { // eslint-disable-line

    "use strict";

    var pluginName = 'grFormUpload';

    // Constructor

    function grFormUpload(selector) {
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;
        this.placeholder = this.selector.getAttribute('placeholder') !== null ? this.selector.getAttribute('placeholder') : 'Browse for file...';
        this.init();
    }

    // Methods

    grFormUpload.prototype.init = function init() {
        if (this.selector === null) {
            throw new Error(pluginName + ': fail - something wrong with your selector');
        } else {
            // Bind all event handlers for referencability
            var arr = ['changeHandler'];
            for (var i = 0, len = arr.length; i < len; i++) {
                var method = arr[i];
                this[method] = this[method].bind(this);
            }
            window.addEventListener('change', this.changeHandler);

            // Flag the plugin as ready
            this.ready = true;
            this.selector.setAttribute('gr-form-upload', 'ready');
            if (groots.verbose) console.log(pluginName + '(' + this.selector.id + '): ready');

            this.build();
        }
    };

    grFormUpload.prototype.build = function build(event) {
        this.state = 'processing';
        global.methods.toggleAttributeValue(this.selector, 'gr-form-upload', this.state);
        if (groots.verbose) console.log(pluginName + '(' + this.selector.id + '): '+ this.state);

        var fake_label = document.createElement('label');
        fake_label.setAttribute('for', this.selector.id);

        fake_label.innerHTML = this.placeholder;

        var trigger = document.createElement('span');
        trigger.className = 'gr-form-upload__trigger icon';

        var collection = [this.selector, fake_label, trigger];

        var wrapper = document.createElement('div');
        wrapper.className = 'gr-form-upload__wrapper';
        wrapper.className = 'gr-form-upload__wrapper';

        global.methods.wrapAll(collection, wrapper);

        trigger.addEventListener('click', this.clickHandler);


        global.methods.removeAttributeValue(this.selector, 'gr-form-upload', this.state);
        this.state = 'done';
        global.methods.toggleAttributeValue(this.selector, 'gr-form-upload', this.state);
        if (groots.verbose) console.log(pluginName + '(' + this.selector.id + '): '+ this.state);
    };

    grFormUpload.prototype.changeHandler = function changeHandler(event) {

        console.log(pluginName + ': changed');
        if (this.selector.value != '') {
            var filename = this.selector.value.split('/');
            this.selector.nextElementSibling.innerHTML = filename.slice(-1)[0].replace("C:\\fakepath\\", "");
            this.selector.nextElementSibling.nextElementSibling.classList.add('has-close');
        }
    };

    grFormUpload.prototype.clickHandler = function clickHandler(event) {
        var input = event.target.parentNode.querySelector('input[type=file]');
        var placeholder = input.getAttribute('placeholder') !== null ? input.getAttribute('placeholder') : 'Browse for file...';

        if (event.target.classList.contains('has-close')  ) {
            event.target.classList.remove('has-close');
            input.value = '';
            input.nextElementSibling.innerHTML = placeholder;
        } else {
            input.click();
        }
    };

    var all = {};
    var allAr = [];
    var index;

    if (document.querySelectorAll('[gr-form] input[type=file]').length) {
        window.groots.grFormUpload = { instances: {} };
        all = document.querySelectorAll('[gr-form] input[type=file]');
        allAr = Array.prototype.slice.call(all);
        Array.prototype.forEach.call(allAr, function(item, index){
            if (item.closest('.is-hidden') !== null) {
                allAr.splice(index, 1);
            }
        });
        index = -1;
        while (allAr[++index])
            global.grFormUpload.instances[index] = new grFormUpload(allAr[index]);
    }

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = grFormUpload;
    // Export to Browser
    else global[pluginName] = grFormUpload; // eslint-disable-line

}( window.groots ));
